import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './vehiclesTableFilters';

const VehiclesTable = ({tableColumns, tableData}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination
  );

  return (
    <Table className='interactive' compact striped {...getTableProps()}>
      <Table.Header>
        {headerGroups.map((headerGroup, index) => (
          <Table.Row key='index' {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`title-${index}`}
                textAlign='center'
                {...column.getHeaderProps()}
              >
                {column.render('Header')}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
        {headerGroups.map((headerGroup) => (
          <Table.Row key='filters' id='filters'>
            {headerGroup.headers.map((column, index) => (
              <Table.HeaderCell
                key={`filter-${index}`}
                className={index === 3 || index === 6 ? 'dropdown-header' : ''}
                textAlign='center'
              >
                {<Filter column={column} />}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        ))}
      </Table.Header>
      <Table.Body {...getTableBodyProps()}>
        {!page.length && (
          <Table.Row>
            <Table.Cell key='index' colSpan={15} textAlign='center'>
              No hay datos disponibles
            </Table.Cell>
          </Table.Row>
        )}
        {page.length > 0 &&
          page.map((row, i) => {
            prepareRow(row);
            return (
              <Table.Row key={i} {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  return (
                    <Table.Cell key={index} textAlign='center' {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </Table.Cell>
                  );
                })}
              </Table.Row>
            );
          })}
      </Table.Body>
      {page.length > 0 && (
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={3} textAlign='left'>
              <Button
                className='navigation-button'
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content='Anterior'
              />
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={2} textAlign='right'>
              <span>páginas </span>
              <span>
                <Input
                  className='pages-input'
                  type='number'
                  value={pageIndex + 1}
                  min='1'
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={2} textAlign='left'>
              <Dropdown
                className='page-sizes-selection'
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span>filas</span>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan={3} textAlign='right'>
              <Button
                className='navigation-button'
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content='Siguiente'
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

export default VehiclesTable;
